import * as types from './types';

const INITIAL_STATE = {
  truckRouteListData: [],
  truckRouteListDataLoading: false,
  truckRouteListDataLoadingError: null,
  truckRouteScheduleDetailData: null,
  truckRouteScheduleDetailLoading: false,
  truckRouteScheduleDetailError: null,
  saveRouteScheduleLoading: false,
  saveError: null,
  savedRouteSchedule: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_TRUCK_ROUTE_LIST:
      return { ...state, truckRouteListData: action.payload };
    case types.GET_TRUCK_ROUTE_LIST_LOADING:
      return { ...state, truckRouteListDataLoading: action.payload };
    case types.GET_TRUCK_ROUTE_LIST_LOADING_ERROR:
      return { ...state, truckRouteListDataLoadingError: action.payload };
    case types.GET_TRUCK_ROUTE_SCHEDULE_DETAILS:
      return { ...state, truckRouteScheduleDetailData: action.payload };
    case types.GET_TRUCK_ROUTE_SCHEDULE_DETAILS_LOADING:
      return { ...state, truckRouteScheduleDetailLoading: action.payload };
    case types.GET_TRUCK_ROUTE_SCHEDULE_DETAILS_ERROR:
      return { ...state, truckRouteScheduleDetailError: action.payload };
    case types.SAVE_TRUCK_ROUTE_SCHEDULE_LOADING:
      return { ...state, saveRouteScheduleLoading: action.payload };
    case types.SAVE_TRUCK_ROUTE_SCHEDULE_ERROR:
      return { ...state, saveError: action.payload };
    case types.SAVE_TRUCK_ROUTE_SCHEDULE:
      return { ...state, savedRouteSchedule: action.payload };
    case types.CLEAR_SAVE_TRUCK_ROUTE_SCHEDULE:
      return {
        ...state,
        savedRouteSchedule: '',
        saveRouteScheduleLoading: false,
      };
    case types.CLEAR_TRUCK_ROUTE_SCHEDULE_ERRORS:
      return {
        ...state,
        truckRouteListDataLoadingError: null,
        truckRouteScheduleDetailError: null,
        saveError: null,
        saveRouteScheduleLoading: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/state/createedittruckrouteschedule/reducer.js